// extracted by mini-css-extract-plugin
module.exports = {"base":"ClustersOverview_base__3cUwz"};